import firebase from '../../../firebase'

import { addUserToConversavtion } from '../middleware/conversation-fire'

export const sendChatNotification = ({conversationData}) => (dispatch, getState) => {

  return dispatch({
    type: "sendChatNotification",
    conversationData
  })

}

export const getUserConversations = () => (dispatch, getState) => {

  return dispatch({
    type: "getUserConversations",
    userId: getState().user.uid,
  })

}

export const searchContacts = (term) => (dispatch, getState) => {

  return Promise.resolve(term)

    .then(response => {

      return dispatch({
        type: "serachContacts",
        term
      })

    })

    .then(term => {

      return findPublicUserPorfiles(term)

    })

    .then(profilesResponse => {

      return dispatch({
        type: "serachContactsResponse",
        profilesResponse
      })

    })

}

export const acceptConversationRequest = (conversationData) => (dispatch, getState) => {
  var {user: {uid}} = getState()

  return Promise.resolve(conversationData)

    .then(conversationData => {

      return pullTempToken(conversationData)
    })

    .then(chatToken => {

      return addUserToConversavtion({
        chatToken: chatToken.replace('token-', ''),
        userId: uid,
        conversationData
      })

    })

}

export const pullTempToken = async(conversationData) => {

  var conversationRef = firebase.firestore().collection('conversations').doc(conversationData.id)

  var conversationDoc = await conversationRef.get()


  var data = conversationDoc.data();

  var [token] = Object.keys(data).filter(key => key.indexOf('token-') > -1)

  return token

}


export async function findPublicUserPorfiles(term) {

  var userProfileRef = firebase.firestore().collection('userProfiles')

  var profilesQuery = await userProfileRef.get()

  var profiles = profilesQuery.docs.map(doc => doc.data())

  return profiles

}





// WEBPACK FOOTER //
// ./src/Components/Conversations/actions/index.js